import { useEffect, useState } from "react";
import {
    GET_APPLICATION_LIST,
    GET_APPLICATION_VIEW,
    REPLACE_FILE,
    DELETE_APPLICATION,
    EVALUATION_FILE,
    STARTUP_ALL_APPLICATIONS,
    GET_GRIEVANCE_LIST,
    USER_LIST,
    USER_ACTIVE_INACTIVE
} from "../../../constants/api";
import { get, post } from "../../../effects/api/api.common";
// import ContactSectionComponent from "./ContactSectionComponent";
// import GetApplicationInfoComponent from "./GetApplicationInfoComponenet";
import { useHistory, NavLink } from "react-router-dom";
import search from '../../../images/search.svg';
import { getSessionStorageValue } from "../../../effects/utils/session-storage";
import { filterByValue } from "../../../utils/CommonMethods";
// import { FormatDate } from "../../../../utils/DateFormat";
// import { downloadDocument } from "../../../../utils/CommonMethods";
/** Render Application Status for Incubator screen */
function ViewUserComponent() {
    const history = useHistory();
    const [activeIndex, setActiveIndex] = useState("grievances");
    const [activeTab, setActiveTab] = useState("grievances");
    const [noDataFilter, setNoDataFilter] = useState('');
    const [showToEac, setShowToEac] = useState(false);
    const [userList, setUserList] = useState([]);
    const [filteredUserList, setFilteredUserList] = useState<any>([]);
    const [loggedInRole, setLoggedInRole] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);

        if (getSessionStorageValue("user")) {
            const user: any = getSessionStorageValue("user");
            const userInfo = JSON.parse(user)
            setLoggedInRole(userInfo.roles);
            if (userInfo.roles == 'dpiit') {
                setShowToEac(false);
            }
            else if (userInfo.roles == 'secretariat') {
                setShowToEac(false);
            }
            else if (userInfo.roles == 'eac') {
                setShowToEac(true)
            }
        }
        else {
            setShowToEac(false);
        }
        getUserList();
    }, []);
    const changeActive = (tabs: any) => {
        setActiveIndex(tabs)
    }

    const getUserList = () => {
        post(USER_LIST, '').then((response: any) => {
            if (!response || !response.data) return;
            setUserList(response.data.data)
        });
    };

    const searchList = (e: any) => {
        setNoDataFilter(e.target.value)
        const filteredData = filterByValue(userList, e.target.value);
        setFilteredUserList(filteredData)

        // console.log(filteredData)    
    }
    const handleAllCheck = (e: any /*index:number*/, id: any) => {
        var name = e.target.name;
        var isChecked = e.target.checked;
        if (isChecked) {
            const payload = {
                "action": "active",
                "user_id": id
            }
            post(USER_ACTIVE_INACTIVE, payload).then((response: any) => {
                if (!response || !response.data) return;
                if (response.data.result == "success") {
                    getUserList()
                    if(filteredUserList.length!=0){
                        let index=filteredUserList.findIndex((p:any) => p.id == id);
                        filteredUserList[index].status=1
                        setFilteredUserList(filteredUserList)     
                      }
                }
            });
        } else if (isChecked == false) {
            const payload = {
                "action": "inactive",
                "user_id": id
            }
            post(USER_ACTIVE_INACTIVE, payload).then((response: any) => {
                if (!response || !response.data) return;
                if (response.data.result == "success") {
                    getUserList()
                    if(filteredUserList.length!=0){
                        let index=filteredUserList.findIndex((p:any) => p.id == id);
                        filteredUserList[index].status=0
                        setFilteredUserList(filteredUserList)                        
                        
                      }
                }
            });
        }
    };


    return (
        <div className="app-inside app-apply-incubator">
            <div className="status-list-wrapper mt-4">
                <div className="container">
                    <div className="d-flex justify-content-between">
                        <div className="col-4 text-left">
                            <p className="dashboard">Users</p>
                        </div>
                        <div className=" text-right">
                            {showToEac == false ? loggedInRole=='dpiit'?<NavLink exact={true} className="btn-sisfs btn-transparent-primary mb-4" activeClassName='active' to='/user_add'>Add User</NavLink>:<NavLink exact={true} className="btn-sisfs btn-transparent-primary mb-4" activeClassName='active' to='/user_add_secretariat'>Add User</NavLink> : <NavLink exact={true} className="btn-sisfs btn-transparent-primary mb-4" activeClassName='active' to='/user_add_eac'>Add User</NavLink>}
                        </div>
                    </div>
                    <div className=" text-right">

                        <div className=" text-right">
                            <div className="d-flex searchDiv align-self-end mt-3 justify-content-end"> <img
                                src={search}
                                className="search"
                                alt="search"

                            />
                                <input
                                    className="searchBar"
                                    type="text"
                                    placeholder="Search.."
                                    name="search"
                                    onKeyUp={searchList}
                                /></div>

                        </div>

                    </div>

                    <div className="app-inside-content">


                        <div className="tab-pane active" id="tabs-1">
                            {/* <div className="row incubator-heading-review mt-3">
                                        <div className="col-md-6 text-left">
                                            
                                        </div>
                                        
                                    </div>    */}

                            <div className="table-scroll mb-4">
                                <table className="reviewTable userListTable" >
                                    <thead>
                                        <tr>
                                            <th className="text-left table-heading custom-td-left table-heading ">Name</th>
                                            <th className="text-left table-heading">Designation</th>
                                            <th className="text-left table-heading">Email</th>
                                            <th className="text-left table-heading">Role</th>
                                            <th className="text-left table-heading">Activate / Deactivate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userList.length == 0 || (filteredUserList.length == 0 && noDataFilter != '') ? <tr><td className="text-center" colSpan={5}>No data</td></tr> :
                                            (filteredUserList.length == 0 ?
                                                userList.map((item: any) => (
                                                    <tr key={item.id}>
                                                        <td className="text-left custom-td">{item.name}</td>
                                                        <td className="text-left custom-td">{item.designation}</td>
                                                        <td className="text-left custom-td">{item.email}</td>
                                                        <td className="text-left custom-td">{item.roles}</td>
                                                        <td className="text-center custom-td slider-td"><label className="switch">
                                                            <input type="checkbox" checked={item.status == 1 ? true : false} onChange={(e: any) => handleAllCheck(e, item.id)} />
                                                            <span className="slider round"></span>
                                                        </label></td>

                                                    </tr>
                                                )) :
                                                filteredUserList.map((item: any) => (
                                                    <tr key={item.id}>
                                                        <td className="text-left custom-td">{item.name}</td>
                                                        <td className="text-left custom-td">{item.designation}</td>
                                                        <td className="text-left custom-td">{item.email}</td>
                                                        <td className="text-left custom-td">{item.roles}</td>
                                                        <td className="text-center custom-td slider-td"><label className="switch">
                                                            <input type="checkbox" checked={item.status == 1 ? true : false} onChange={(e: any) => handleAllCheck(e, item.id)} />
                                                            <span className="slider round"></span>
                                                        </label></td>
                                                    </tr>
                                                ))
                                            )}
                                        {/* {userList.length == 0 ?
                                            <tr><td className="text-center" colSpan={5}>No data</td></tr> :
                                            userList.map((item: any) => (
                                                <tr>
                                                    <td className="text-left custom-td">{item.name}</td>
                                                    <td className="text-left custom-td">{item.designation}</td>
                                                    <td className="text-left custom-td">{item.email}</td>
                                                    <td className="text-left custom-td">{item.roles}</td>

                                                </tr>
                                            ))} */}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    );
}

export default ViewUserComponent;
